import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { history, store, persistor } from 'store';
import { ThemeProvider as MaterialThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Router from 'router';
import { CookiesProvider } from 'react-cookie';

import Loading from 'components/Loading';
import theme from './themes';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptbrLocale from 'date-fns/locale/pt-BR';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <CookiesProvider>
        <PersistGate loading={<Loading />} persistor={persistor}>
          <MaterialThemeProvider theme={theme}>
            <CssBaseline />
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptbrLocale}>
              <Suspense fallback={<Loading />}>
                <Router history={history} />
              </Suspense>
            </MuiPickersUtilsProvider>
          </MaterialThemeProvider>
        </PersistGate>
      </CookiesProvider>
    </Provider>
  );
};

export default App;
